var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#717680",
  d: "M15.442 14.559a.625.625 0 0 1-.884.884L10 10.884 5.44 15.443a.623.623 0 0 1-.883 0 .625.625 0 0 1 0-.884L9.116 10 4.558 5.442a.625.625 0 1 1 .884-.884l4.559 4.558 4.558-4.558a.625.625 0 1 1 .884.884L10.885 10z"
})));
export default SvgClose;